import { ProductCategory } from "@utils/constants";

export const getProductLevelColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-03";
    case ProductCategory.GEMSTONE:
      return "gem-03";
    case ProductCategory.JEWELRY:
      return "jewelry-03";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-03";
    default:
      return "diam-03";
  }
};

export enum SummaryBoxEnum {
  DISCOUNT = "disc",
  PRICE_PER_CARAT = "price_per_carat",
}
